import { createComponent } from '@carvana/merch-components';

export const GradientOverlay = createComponent('div', {
  className:
    'pointer-events-none absolute inset-x-0 top-0 h-[100px] bg-[linear-gradient(0deg,rgba(26,26,26,0)_21.61%,rgba(26,26,26,0.61)_50.68%,#1A1A1A_85.83%)]'
});
